import { tss } from 'tss-react/mui';
import Typography from '@mui/material/Typography';

import { Or2ButtonStyledAsLink } from '../button/Or2ButtonStyledAsLink';

const useStyles = tss.create(() => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    textAlign: 'center',
    padding: 10,
    minWidth: 80,
  },
}));

export const GenericError = () => {
  const { classes } = useStyles();
  return (
    <div className={classes.root}>
      <Typography>
        Something seems to have gone wrong. Try{' '}
        <Or2ButtonStyledAsLink
          onClick={(evt: React.SyntheticEvent) => {
            evt.preventDefault();
            location.reload();
          }}
        >
          refreshing
        </Or2ButtonStyledAsLink>{' '}
        or, if that doesn&apos;t work, then get in touch with GovernorHub
        Support.
      </Typography>
    </div>
  );
};
